'use client'

// import { Edit } from '@mui/icons-material'
import {
	Box,
	Card,
	CardContent,
	CardHeader,
	//  IconButton,
	Stack,
	Typography
} from '@mui/material'
// import { NavLink } from 'react-router'

export default function AddressCard({ item }: any) {
	return (
		<Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<CardHeader
				title={item?.alias}
				// action={
				// 	<IconButton LinkComponent={NavLink} href={`/settings/addresses/${item.id}/edit`}>
				// 		<Edit />
				// 	</IconButton>
				// }
			/>
			<CardContent sx={{ display: 'flex', flex: 1 }}>
				<Stack sx={{ height: '100%', gap: 2 }}>
					<Box sx={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
						<Typography variant="h6">{item?.name}</Typography>
						<Typography variant="body1">{item?.streetAddress}</Typography>
						<Typography variant="body1">{item?.streetAddress2}</Typography>
						<Typography variant="body1">
							{item?.city}, {item?.state}, {item?.postalCode}
						</Typography>
						<Typography variant="body1">{item?.country}</Typography>
					</Box>
					<Box>
						<Typography variant="caption">{item?.type}</Typography>
					</Box>
				</Stack>
			</CardContent>
		</Card>
	)
}
